import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { QuoteRate } from '@views/screens/Quote';
import type { AxiosResponse } from 'axios';

const getCreateQuoteRateResultsApi = (encodedKey: string) => {
  return axiosInstance.request({
    url: `${API.BASE}/rate/cached-quote-rate-results/${encodedKey}`,
    method: 'get',
  });
};

export type CreateQuoteRateResultsResponse = {
  encodedRatesKey: string | null;
  rateResults: QuoteRate[];
};

export const fetchCreateQuoteRateResults = async (encodedKey: string): Promise<CreateQuoteRateResultsResponse> => {
  const response: AxiosResponse<CreateQuoteRateResultsResponse> = await getCreateQuoteRateResultsApi(encodedKey);
  return response.data;
};
